import * as dntShim from "../_dnt.shims.js";
import { zodToJsonSchema } from 'zod-to-json-schema';
export const LOCAL_STORAGE_USER_ID_KEY = '___orama_anonymous_user_id';
export const LOCAL_STORAGE_SERVER_SIDE_SESSION_KEY = '___orama_server_side_session';
export function createRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-$';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}
export function formatDuration(duration) {
    if (duration < 1000) {
        return `${duration}ms`;
    }
    else {
        const seconds = duration / 1000;
        if (Number.isInteger(seconds)) {
            return `${seconds}s`;
        }
        return `${seconds.toFixed(1)}s`;
    }
}
export function sendBeacon(endpoint, body) {
    if (typeof navigator !== 'undefined') {
        if (typeof navigator.sendBeacon !== 'undefined') {
            navigator.sendBeacon(endpoint, body);
        }
        return;
    }
    fetch(endpoint, {
        method: 'POST',
        body,
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(() => { }, (e) => console.log(e));
}
export const hasLocalStorage = typeof localStorage !== 'undefined';
export function throttle(func, limit) {
    let inThrottle;
    return function (...args) {
        if (!inThrottle) {
            // @ts-ignore - 'this' has implicitly any, yes
            func.apply(this, args);
            inThrottle = true;
            setTimeout(() => (inThrottle = false), limit);
        }
    };
}
export function debounce(func, delay) {
    let debounceTimer;
    return function (...args) {
        clearTimeout(debounceTimer);
        // @ts-ignore - 'this' has implicitly any, yes
        debounceTimer = setTimeout(() => func.apply(this, args), delay);
    };
}
export function isServerRuntime() {
    // Browser detection: if window or document exists, you're definitely in a browser
    if (typeof dntShim.dntGlobalThis !== 'undefined' || typeof document !== 'undefined') {
        return false;
    }
    // Node.js
    // @ts-ignore - process is not defined
    if (typeof process !== 'undefined' && process.versions?.node) {
        return true;
    }
    // Deno
    // @ts-ignore - Deno is not defined
    if (typeof Deno !== 'undefined' && typeof Deno.version !== 'undefined') {
        return true;
    }
    // Bun
    // @ts-ignore - Bun is not defined
    if (typeof Bun !== 'undefined' && typeof Bun.version !== 'undefined') {
        return true;
    }
    // Cloudflare Workers, Vercel Edge, and other serverless environments often run in a V8 isolate
    if (typeof dntShim.dntGlobalThis !== 'undefined' &&
        typeof globalThis.Response === 'function' &&
        typeof globalThis.fetch === 'function' &&
        typeof globalThis.navigator === 'undefined' // real browser usually has navigator
    ) {
        return true;
    }
    // AWS Lambda or generic serverless
    // @ts-ignore - process is not defined
    if (typeof process !== 'undefined' && process?.env.AWS_LAMBDA_FUNCTION_NAME) {
        return true;
    }
    // Default to false if it looks like a browser
    return false;
}
export function flattenZodSchema(schema) {
    const raw = zodToJsonSchema(schema, 'Tool');
    if (raw.$ref && raw.definitions) {
        const defName = raw.$ref.replace('#/definitions/', '');
        const flattened = raw.definitions[defName];
        if (!flattened) {
            throw new Error(`Could not resolve definition: ${defName}`);
        }
        return flattened;
    }
    return raw;
}
